// templates
import {getOrgImages} from "./apiv2-requests";
import TagSwitchesSource from "./filters/TagSwitchesSource";
import {GroupsListFilter} from "./filters/groupsListFilter";
import {Spinner} from "./spinner";

let currentCategories = []
let currentPage = 1

const TagListItem = (tag) => `<li data-filter-by="tag" data-filter="${tag}"><a href="#" role="checkbox" aria-checked="false">${tag}</a></li>`
const TagsBlock = (label, tags) => `
<div class="image-tags-wrapper">
    <h3>${label}</h3>
    <ul class="custom-scroll tags-list" data-filter-options="{&quot;op&quot;:&quot;merge&quot;}">${tags.map(TagListItem).join('')}</ul>
</div>`
const ImageItem = (image, tags) => $(`<div class="images-item"><a href="#"><img src="${image}"></a></div>`).attr('data-tags', JSON.stringify(tags)).wrap('<p/>').parent().html();
const ImagesBlock = () => `<div class="images-block"></div>`
const PaginationBlock = () => `<div class="pagination-block"></div>`
const loadImages = async (container, pagesContainer, categories = [], page = 1) => {
    const $container = $(container)
    if ($container.length === 0) {
        return false
    }
    $container.html('')
    const spinner = new Spinner($container)
    spinner.show('')
    const response = await getOrgImages(categories, page)
    spinner.remove()
    currentCategories = categories
    currentPage = page
    response.records.forEach(image => $container.append(ImageItem(image.imagePath, image.categories)))
    if (pagesContainer.length > 0 && typeof response.pagination !== 'undefined') {
        pagesContainer.html('')
        pagesContainer.append(Pagination(response.pagination.totalPages, page))
    }

}
const closeButton = () => `
<button type="button" class="close" aria-label="Close"><span><svg class="svg-sprite window-close" viewBox="0 0 27 27" aria-label="Close"><title>Close</title><use xlink:href="#icon-close"></use></svg></span></button>
`
const PageBtn = (num, label, isCurrent) => `<a href="#" class="btn-page ${isCurrent ? 'current' : ''}" data-page="${num}">${label}</a>`
const Pagination = function (totalPages, activePage) {
    if (totalPages <= 1) {
        return ''
    }
    let buttons = []
    const min = Math.max(1, Math.min(activePage - 2, totalPages - 4))
    const max = Math.min(Math.max(min + 4, activePage + 2), totalPages)

    if (min > 1) {
        buttons.push(PageBtn(1, '<<', false))
        buttons.push(PageBtn(activePage - 1, '<', false))
    }
    for (let i = min; i <= max; i++) {
        buttons.push(PageBtn(i, i, i === activePage))
    }
    if (max < totalPages) {
        buttons.push(PageBtn(activePage + 1, '>', false))
        buttons.push(PageBtn(totalPages, '>>', false))
    }
    return buttons.join('')
}

const ModalBuilder = () => {
    let innerHtml = `<div class="header"><h2>Select an image from the repository</h2>${closeButton()}</div>`
    if (window.community.tags) {
        innerHtml += TagsBlock('All search tags', window.community.tags)
    }
    innerHtml += window.community.tagsGroups
        .map(group => group.tags ? TagsBlock(group.name, group.tags) : '')
        .join('')
    innerHtml += ImagesBlock()
    innerHtml += PaginationBlock()
    return `<dialog id="SelectImage">${innerHtml}</dialog>`
}

const bindTags = function ($modal) {
    const tagButtons = $('.tags-list li[data-filter-by="tag"], [data-filter-by="clear"]', $modal)
    const switches = new TagSwitchesSource(tagButtons)
    tagButtons.children('a').click(function () {
        switches.switch($(this).parent())
        return false
    })
    return switches
}

export default function selectImage() {
    return new Promise((resolve, reject) => {
        $('body').append(ModalBuilder())
        const modal = document.getElementById('SelectImage')
        modal.showModal()
        const $modal = $(modal)
        $modal.on('close', () => {
            resolve(modal.returnValue)
            $modal.remove()
        })
        $modal.find('.close').on('click', () => {
            modal.close('')
        })
        $modal.on('click', '.images-block a', function () {
            modal.close($(this).find('img').attr('src'))
        })
        const $images = $modal.find('.images-block')
        const $pagination = $modal.find('.pagination-block')

        bindTags($modal).on('update', function() {
            const categories = $('.tags-list li[data-filter-by="tag"].selected', $modal)
                .map((i, el) => $(el).data('filter'))
                .get()
            loadImages($images, $pagination, categories, 1)
        })
        loadImages($images, $pagination)
        $pagination.on('click', 'a', function() {
            loadImages($images, $pagination, currentCategories, $(this).data('page'))
            return false
        })
    })
}
